export default __webpack_public_path__ + "static/media/flute.e50e8b97.svg";